import { MappedTerminalData } from '@helpers/getTerminalsFromStep';
import { CrossDockingOperation } from '@services/requests/orderService/types';

/**
 * Функция выполняет расчет полной стоимости для группы услуг по терминалу
 * @param terminals
 */
export const getFullPriceFromTerminals = (
  terminals: MappedTerminalData[],
  crossDockingOperations: CrossDockingOperation[]
) => {
  const [terminal] = terminals;

  return [
    ...(terminals ?? []).map((terminal) => [
      ...(terminal.terminalAllowances ?? []).map(
        (allowance) =>
          (allowance.calculatedPrice?.priceInTargetCurrency ?? 0) +
          (allowance.calculatedPrice?.taxInTargetCurrency ?? 0)
      ),
      (terminal.terminalCalculatedPrice?.taxInTargetCurrency ?? 0) +
        (terminal.terminalCalculatedPrice?.priceInTargetCurrency ?? 0),
    ]),
    ...crossDockingOperations
      .filter((operation) => operation.terminalId.toString() === terminal.terminal.id)
      .map((operation) => [
        ...(operation.allowances ?? []).map(
          (allowance) =>
            (allowance.calculatedPrice?.priceInTargetCurrency ?? 0) +
            (allowance.calculatedPrice?.taxInTargetCurrency ?? 0)
        ),
        (operation.calculatedPrice?.taxInTargetCurrency ?? 0) +
          (operation.calculatedPrice?.priceInTargetCurrency ?? 0),
      ]),
  ]
    .flat()
    .reduce((sum, val) => sum + val, 0);
};

/**
 * Функция вычисляет полную стоимости расходов на терминалах
 * @param terminals
 */
export const totalTerminalsPrice = (
  terminals: MappedTerminalData[][],
  crossDockingOperations: CrossDockingOperation[]
) =>
  terminals
    .map((terminal) => getFullPriceFromTerminals(terminal, crossDockingOperations))
    .reduce((sum, val) => sum + val, 0);
